import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=565cd49a&scoped=true"
import script from "./Partnership.vue?vue&type=script&lang=js"
export * from "./Partnership.vue?vue&type=script&lang=js"
import style0 from "./Partnership.vue?vue&type=style&index=0&id=565cd49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cd49a",
  null
  
)

export default component.exports